<template>
  <div :class="['container ub ub-ver', { 'container-dark': theme_dark }]">
    <ul class="title ub ub-ac1 ub-pc">

        <li class="item ub ub-ac ub-pc ub-ver">
          <div class="bg-msg-img2 ub ub-ac ub-pc" @click="goto_hello()">
            <img src="../assets/img/new2024/hello1.png" class="coin">
          </div>
          <div class="item-span2 ub">
            <span >打招呼</span><a>+{{ num_people }}</a>
          </div>
        </li>

      <li class="item ub ub-ac ub-pc ub-ver">
        <div class="bg-msg-img ub ub-ac ub-pc" @click="goto_giftdtl()">
          <img src="../assets/img/new2024/gift-icon.png" />
        </div>
        <div class="item-span">
          <span >礼物墙</span>
        </div>
      </li>

      <li class="item ub ub-ac ub-pc ub-ver">
        <div class="bg-msg-img ub ub-ac ub-pc" @click="goto_friend()">
          <img src="../assets/img/new2024/friend-icon.png" />
        </div>
        <div class="item-span">
          <span>我的好友</span>
        </div>
      </li>
    </ul>

    <div class="content">
        <div class="all-msg ub ub-pc">
            <img class="msg-icon" src="../assets/img/new2024/msg-icon.png" />
            <div class="item">
              <span>全部消息</span>
            </div>
            <img class="bg-msg2" src="../assets/img/new2024/bg-all.png" alt="">
        </div>
      

      <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="c_friend.length <= 0">
        <img src="../assets/img/new2024/no-msg.png" alt=""/>
        <span class="tip-404">暂无更多消息</span>
      </div>

      <div class="msg-block" v-if="c_friend.length > 0">
        <div class="line"></div>
        <ul>
          <li v-for="(item,index) in c_friend" :key="index" :class="{move:candelete.id==item.id}" @touchstart="touchStart(item)" @touchend="touchEnd(item)">
            <div class="msg-item ub ub-pc" @click="goto_chart(item.uid)">
                <img :src="item.photo" class="msg-img" />
                <div class="ub ub-ver ub-f1">
                  <div class="msg-txt ub ub-pc">
                    <div class="ub">
                      {{item.nick}}
                      <div class="friend tag ub ub-pc" v-if="item.is_friend && item.uid !== xhc_admin_uid">
                        <img src="../assets/img/new2024/friend.png" alt="">
                        <span >好友</span>
                      </div>
                      <div class="mosheng tag ub ub-pc" v-if="!item.is_friend && item.uid !== xhc_admin_uid">
                        <img src="../assets/img/new2024/stranger.png" alt="">
                        <span>陌生人</span>
                      </div>
                      <div class="official tag ub ub-pc" v-if="item.uid == xhc_admin_uid">
                        <img src="../assets/img/new2024/official.png" alt="">
                        <span >官方</span>
                      </div>
                    </div>
                    <div class="tip">{{item.dtm_sp}}</div>
                  </div>
                  <div class="msg-txt ub ub-pc">
                    <div class="tip">{{item.least_msg}}</div>
                    <div class="red-tag" v-if="item.noread > 0">{{item.noread}}</div>
                  </div>
                </div>
            </div>
            
            <div class="del" @click="deleteItem(item)">删除</div>
            <div class="line"></div>
          </li>
        </ul>
      </div>

      <div class="emptyH"></div>

    </div>

    <alert ref="myConfirm_buyVip" @userBehavior="formact_buyVip"></alert>
    <dlg ref="myForm_makeMoney" @formBehavior="formact_makeMoney"></dlg>
    <alert ref="myConfirm_openDark" @userBehavior="formact_opendark"></alert>
    <dlg ref="myForm_chat_score" @formBehavior="formact_chatScore"></dlg>
    <reward_coin ref="show_reward_coin" ></reward_coin>
    <reward_score ref="show_reward_score" ></reward_score>
  </div>
</template>
<script>
import Alert from "../components/Alert.vue";
import Form from "../components/Form.vue";
import Coin_Reward from "../components/Coin_Reward.vue";
import Score_Reward from "../components/Score_Reward.vue";
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
export default {
  components: {
    alert: Alert,
    dlg: Form,
    reward_coin: Coin_Reward,
    reward_score: Score_Reward
  },
  data() {
    return {
      userinfo: {
        sex: "",
        vip_level: 0,
        vip_tag: 0,
        vip_time: 0,
        score_total: 0,
        chat_mny_score: 0
      },

      rz_tag: false,
      onLine: [],
      swiperOption: {
        direction: "horizontal",

        freeMode: true,
        observeParents: true, //观察父组件，当父组件变化时，自己随着变化
        observer: true, //观察自己，自己的参数变化时，更新
        centeredSlides: true, //设置为true时，活动块居中显示，默认下居左显示
        loop: false, //滑动过程中会在前后复制多个slider,效果看起来是循环的
        loopedSlides: 3, //设置滑动过程中所要用到的loop个数
        slidesPerView: "auto", //同时显示的slide数量
        loopAdditionalSlides: 100,
        autoPlay: {
          delay: 3000,
          disableOnInteraction: false, //鼠标移动上去时是否继续播放
        },
        paginationType: "bullets",
        paginationElement: "span",
      },
      clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
      candelete: {}, // 滑动的item
      xhc_admin_uid: '',
      theme_dark: false,
      num_people: 0 //挣积分人数
    };
  },
  computed: {
    c_friend: function () {
      return this.get_friend();
    },
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);

    //是否弹出夜间弹窗
    if (!this.$cookies.isKey("cookie_show_dark")) {
      var is_show = this.is_show_dark_model();
      if (is_show) {
        this.show_dark_model();
      }
      this.$cookies.set("cookie_show_dark", 1, 4 * 60 * 60);
    }
    
    //随机挣钱人数
    this.num_people = tool.randomNum(100,200);
    
    this.init_page();
    this.init_admin_uid();
    this.init_page_rzstate();
    this.get_onLine();
  },

  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo","act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_friend() {
      this.$router.push({ name: "friend" });
    },

    goto_hello() {
      if (this.userinfo.sex == "女生") {
        this.$router.push({ name: "hello_boy" });
      }
      if (this.userinfo.sex == "男生") {
        this.$router.push({ name: "hello_girl" });
      }
    },

    goto_giftdtl() {
      this.$router.push({ name: "my_gift" });
    },

    is_show_dark_model() {
      var rtn = false;
      var objVal = this.$store.state.objVal;
        var is_first_dark = objVal.is_first_dark;
        var theme_dark = objVal.theme_dark;
        if (is_first_dark) {
          var currentHour = new Date().getHours();
          if (currentHour >= 19 || currentHour <= 7 ) {
            if (!theme_dark) {
              rtn = true;
            }
          }
        }
      return rtn;
    },

    init_page() {
      var objVal = this.$store.state.objVal;
      // var chat_score_promote = objVal.chat_score_promote;
      
      var self = this;
      var uid = this.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          self.userinfo.sex = u.sex;
          self.userinfo.vip_level = u.vip_level;
          self.userinfo.score_total = u.score_total;
          self.userinfo.vip_time = tool.dateDiff2(
            new Date(),
            new Date(u.death_time2)
          );
          self.userinfo.chat_mny_score = u.chat_mny_score;
          switch (u.vip_tag) {
            case 0:
              self.userinfo.vip_tag = "";
              break;
            case 1:
              self.userinfo.vip_tag = "VIP";
              break;
            case 2:
              self.userinfo.vip_tag = "SVIP";
              break;
          }

          self.newUser_reward_coin(u);
          self.newUser_reward_score(u);
        },
      });
      
    },

    init_admin_uid() {
      var sysdic = this.$store.state.sysdic;
      if(sysdic) {
        this.xhc_admin_uid = sysdic.xhc_admin_uid
      }
    },

    init_page_rzstate() {
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          var sext = u.sex;
          var loc_province = u.loc_province;
          var loc_city = u.loc_city;
          var loc_area = u.loc_area;
          var inst_tag = u.inst_tag;

          var wx = u.wx;
          var tel = u.tel;

          var rz_tel = false;
          var rz_wx = false;
          var rz_info = false;
          if (tel) {
            rz_tel = true;
          }
          if (wx) {
            rz_wx = true;
          }
          if (loc_province && loc_city && loc_area && inst_tag) {
            rz_info = true;
          }

          if (rz_tel && rz_wx && rz_info) {
            self.rz_tag = true;
          }
        },
      });
    },

    //男生新用户引导
    newUser_reward_coin(info) {
      if (info.sex == "男生" && info.reg_time <= 86400 * 1) {
        var loc_newuser_guide = localStorage.getItem('loc_newuser_guide');
        //已领取
        if(loc_newuser_guide){
          return false;
        }

        var reward = {
          "type": "萌新福利",
          "task_type": 11,
          "coin": 200,
          "tips": "欢迎萌新宝宝，小火柴为新用户赠送了超多福利，明天还可领取300金币",
          "path_name":"task_coin",
          "btn_name":"更多奖励"
        }
        var self = this;
        this.get({
            url: "/App/GetTaskCoinState?uid=" + info.uid,
            success: function (data) {
              var newuser_1 = data.filter(item=> item.type_dtl == "newuser_1");
              if (newuser_1.length <= 0) {
                self.$refs.show_reward_coin.show(reward);
                localStorage.setItem('loc_newuser_guide', "已提示");

                self.get({
                  url: "/App/ReceiveTaskCoin?uid=" + info.uid +"&task_type=" + reward.task_type +"&coin=" + reward.coin,
                  success: function (data) {
                    //领取成功
                    self.act_reload_userinfo();
                  },
                  error: function (err){}
                });
              }
            },
            error: function (err){}
        });
        
      }
    },

    //女生新用户引导
    newUser_reward_score(info) {
      if (info.sex == "女生" && info.reg_time <= 86400 * 1) {
        var loc_newuser_guide = localStorage.getItem('loc_newuser_guide');
        //已领取
        if(loc_newuser_guide){
          return false;
        }

        var reward = {
          "type": "萌新福利",
          "task_type": 1,
          "score": 50,
          "tips": "欢迎萌新宝宝，你已获得聊天赚钱资格，聊聊天就能赚钱，详情点击下方按钮进入了解",
          "path_name":"mkmny",
          "btn_name":"我要赚钱"
        }

        var self = this;
        this.get({
            url: "/App/GetTaskState?uid=" + info.uid,
            success: function (data) {
              var task_login = data.filter(item=> item.type_dtl == "任务奖励-登录");
              if (task_login.length <= 0) {
                self.$refs.show_reward_score.show(reward);
                localStorage.setItem('loc_newuser_guide', "已提示");

                self.get({
                  url: "/App/ReceiveTaskScore?uid=" + info.uid +"&task_type=" + reward.task_type +"&score=" + reward.score,
                  success: function (data) {
                    //领取成功
                    self.act_reload_userinfo();
                  },
                  error: function (err){}
                });
              }
            },
            error: function (err){}
        });
      }
    },

    goto_chart(uid) {
      var jump_url = "chart";
      if(uid == this.xhc_admin_uid) {
        jump_url = "chart_admin";
      }
      this.$router.push({ name: jump_url, params: { uid: uid } });

      //存储在线动作
      tool.set_user_action("goto_chat");
    },

    goto_chart_i() {
      this.$router.push({ name: "chart_i" });
    },
    get_onLine() {
      var online_user = this.$store.state.least_online;
      online_user = this.format_online(online_user);
      this.onLine = online_user;
    },

    get_friend() {
      var friend = [];
      var message = this.$store.state.message;
      var my_friend = this.$store.state.my_friend;


      // console.log(JSON.stringify(message)); 

      for (var i in message) {
        var idx = message[i].txts.length - 1;
        var least_msg = message[i].txts[idx].msg;
        var least_dtm = message[i].txts[idx].dtm;
        var dtm_sp = tool.dateDiff(new Date(least_dtm), new Date());
        var dtm_sp_count = tool.dateDiff2(new Date(least_dtm), new Date());
        if(dtm_sp_count <= 1){
          dtm_sp = '刚刚';
        }
        var msg_type = least_msg.msg_type;
        var msg_txt = least_msg.msg_txt;
        var show_msg = "系统消息";
        switch (msg_type) {
          case "emoji":
            show_msg = "[表情]";
            break;
          case "gif":
            show_msg = "[动画表情]";
            break;
          case "gift":
            show_msg = "[礼物]";
            break;
          case "pic":
            show_msg = "[图片]";
            break;
          case "text":
            show_msg = least_msg.msg_txt;
            if (show_msg.length > 15) {
              show_msg = show_msg.substr(0, 13) + "...";
            }
            break;
          case "voice":
            show_msg = "[语音]";
            break;
          case "sys_guide_hello":
            show_msg = msg_txt;
            break;
          case "sys_warn":
            show_msg = "系统警告";
            break;
          case "sys_kill":
            show_msg = "系统封号";
            break;
        }

        if (msg_type.startsWith('check')) {
          show_msg = "系统提醒";
        }

        var uid = message[i]["to"];
        if (!uid) {
          continue;
        }
        
        var is_friend = tool.check_friend(my_friend, uid);
        var inoread = tool.calculate_noread_count(message, uid);
        var inoread_level = tool.calculate_noread_level(message, uid);

        var self = this;
        this.act_get_userinfo({
          uid: uid,
          success: function (u) {
            if (u) {
              var nick = u.nick.length > 8 ? u.nick.substr(0, 7) + "..." : u.nick;
              var photo = u.photo;
              var url = self.$store.state.url;
              if (photo.indexOf(url) == -1) {
                photo = url + "/photo/" + photo;
              }

              var f_item = {
                uid: uid,
                photo: photo,
                nick: nick,
                vip_tag: u.vip_tag,
                least_msg: show_msg,
                dtm_sp: dtm_sp,
                dtm_sp_count: dtm_sp_count,
                noread: inoread,
                noread_level: inoread_level,
                is_friend: is_friend,
                chat_mny_score: u.chat_mny_score
              };

              friend.push(f_item);
            }
          },
        });
      }

      friend = tool.arry_sort(friend, "dtm_sp_count", "num_asc");
      var noread_sum = 0;
      for (var i = 0; i < friend.length; i++) {
        friend[i].id = i + 1;
        noread_sum += friend[i].noread;
      }
      this.$store.commit('set_objVal', {"msg_noread" : noread_sum});
      return friend;
     
    },

    format_online: function (data) {
      //首先计算tsp
      for (var i in data) {
        var dtm = new Date(data[i].dtm);
        var dtm_now = new Date();
        var sp = tool.dateDiff(dtm, dtm_now);
        data[i].dtm_sp = sp;
      }

      //排序
      data = tool.arry_sort(data, "dtm", "dtm_desc");

      //截断处理，当用户超过60个时候，截断后20个，只留40个
      if (data.length >= 60) {
        data.splice(40, 20);
        //本地store中更新该数据
        this.$store.commit("push_least_online", data);
      }

      return tool.slice_arry(data, 4);
    },

    checkVip(msg) {
      var b = true;

      var vip_level = this.userinfo.vip_level;
      if (vip_level == 0) {
        //购买会员提示
        this.$refs.myConfirm_buyVip.show(msg, {
          type: "confirm",
          confirmText: "升级会员",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      return b;
    },

    formact_buyVip(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "vip_center" });
      }
    },

    formact_makeMoney(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mkmny" });
      }
    },

    /**
     * 删除item
     * index是下标
     */
    deleteItem(item) {
      var chat_mny_score = item.chat_mny_score;
      var last_msg_time = item.dtm_sp_count;
      if (chat_mny_score > 0 && last_msg_time < 60 * 60) {
        //对方删除会话消息的问题（消息列表），会有白嫖的情况
        //不允许删除（如果需要支付金币，并且近1小时有消息
        console.log("不能删");
      } else {
        this.$store.commit("remove_message", item.uid);
      }
      
    },
    touchStart(item) {
      let touchs = event.changedTouches[0];
      // 记录开始滑动的鼠标位置
      this.clientNum.x1 = touchs.pageX;
      this.candelete = {};
    },
    touchEnd(item) {
      let touchs = event.changedTouches[0];
      // 记录结束滑动的鼠标位置
      this.clientNum.x2 = touchs.pageX;
      this.candelete = {};
      // 判断滑动距离大于50，判定为滑动成功，否则失败
      if (
        this.clientNum.x2 < this.clientNum.x1 &&
        Math.abs(this.clientNum.x1) - Math.abs(this.clientNum.x2) > 50
      ) {
        //event.preventDefault();
        this.candelete = item;
      } else if (
        this.clientNum.x2 > this.clientNum.x1 &&
        Math.abs(this.clientNum.x2) - Math.abs(this.clientNum.x1) > 10
      ) {
        //event.preventDefault();
        this.candelete = {};
      }
    },

    //显示切换深色模式弹窗
    show_dark_model() {
        this.$refs.myConfirm_openDark.show('系统自动检测到当前适合开启深色模式，点击确定即可开启哦~ (如需手动设置请前往:我的->系统设置->夜间模式)', {
          type: 'confirm',
          confirmText: '确定',
          titleText: '温馨提示',
          data: ''
        });
        this.$store.commit('set_objVal', {"is_first_dark" : false});
    },

    formact_opendark (type, data) {
        if (type == 'clickConfirm') {
          this.theme_dark = true;
          this.$store.commit('set_objVal', {"theme_dark" : true});
        }
    },
    
    formact_chatScore(type, data) {
      if (type == 'clickConfirm') {
        this.$store.commit('set_objVal', {"chat_score_promote" : true});
      }
    }
      
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f2f2f2;
  .emptyH {
    height: 4rem;
    line-height: 4rem;
  }
}

.title {
  padding: 1rem 0;
  background-color: #FDFDFD;
  .item {
    .bg-msg-img {
      width: 2.75rem;
      height: 2.75rem;
      border-radius: 50%;
    }
    .item-span {
      font-size: 0.75rem;
      margin-top: 0.5rem;
    }
    .bg-msg-img2 {
      width: 2.75rem;
      height: 2.75rem;
      border-radius: 50%;
      background-color: #E13366;
      .coin {
        width: 2rem;
        height: 2rem;
      }
    }
    .item-span2 {
      position: relative;
      font-size: 0.75rem;
      margin-top: 0.5rem;
      a {
        position: absolute;
        right: -1.4rem;
        font-size: 0.6rem;
        color: #FF0000;
      }
    }
  }
  .item:nth-child(1) .bg-msg-img {
    background-color: #E0618C;
    img {
      margin-right: 0.2rem;
    }
  }
  .item:nth-child(2) .bg-msg-img {
    background-color: #AB68DE;
  }

  .item:nth-child(3) .bg-msg-img {
    background-color: #94E7E0;
  }
}

.content {
  min-height: 20rem;
  background-color: #f2f2f2;
  .all-msg {
    padding: 1rem 0;
    background-color: #f2f2f2;
    font-size: 1rem;
    .item {
      background-image: url(../assets/img/new2024/bg-all-msg.png);
      background-repeat: no-repeat;
      background-position:center;
    }
    .msg-icon {
      margin-left: 1rem;
      width: 1rem;
      height: 0.8rem;
    }
    span {
      margin-left: 0.6rem;
    }
    .bg-msg2 {
      width: 0.5rem;
      height: 0.5rem;
    }
  }
  .msg-block {
    ul {
      overflow-x: hidden; /*隐藏ul x轴的滚动条*/
      padding: 0;
      margin: 0;
      li {
        position: relative;
        transform: translateX(0);
        transition: all 0.3s; /*滑动效果更生动*/
        list-style: none;
        .del {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0;
          right: -1px;
          z-index: 3;
          width: 6rem;
          height: 4.5rem;
          text-align: center;
          color: #fff;
          background-color: #ff5b45;
          transform: translateX(6em); /*默认x轴位移60px，使其隐藏*/
        }
      }
      .move {
          transform: translateX(-6em); /*滑动后x轴位移-60px,使其可见*/
      }
    }
    .line {
      margin: 0 0.8rem;
      border-top: 1px solid #FDFDFD;
    }
  }
  .msg-item {
      padding: 0.5rem 0.8rem;
      .msg-img {
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 50%;
      }
      .msg-txt {
        font-size: 0.9rem;
        justify-content: space-between;
        padding: 0.1rem 0.1rem 0.1rem 0.8rem;
        .tag{
          margin-left: 0.75rem;
          padding: 1px 3px;
          font-size: 0.5rem;
          border-radius: 2px;
          span {
            margin-left: 3px;
          }
        }
        .friend{
          background: linear-gradient(180deg, #d2a9f1, #e3769b);
          span {
            color: #fff;
          }
        }
        .mosheng{
          background: #e3e3e3;
          span {
            color: #999;
          }
        }
        .official {
          background-color: #FCDD7F;
          span {
            color: #BA61FF;
          }
        }
        .tip {
          font-size: 0.75rem;
          color: #888;
        }

        .red-tag {
          text-align: center;
          padding: 0 0.3rem;
          border-radius: 0.5rem;
          height: 1rem;
          line-height: 1rem;
          color: #fff;
          background-color: #FF0000;
          font-size: 0.75rem;
        }
      }
  }
  
}

.no-404 {
  margin-top: 2rem;
  background-size: 100% 100%;
  .tip-404 {
    margin-top: 1rem;
    font-size: 0.75rem;
  }
}

//夜间模式
.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  ul.title {
    background-color: #2F2E33;
    .item {
      .item-span {
        color: #dfdfdf;
      }
      .item-span2 {
        color: #dfdfdf;
      }
    }
  }
  .content {
    background-color: #2F2E33;
    .all-msg {
      background-color: #2F2E33;
      span {
        color: #dfdfdf;
      }
    }
    .line {
      border-top: 1px solid #404040;
    }
    .msg-block {
      .msg-item {
        .msg-txt {  
          color: #dfdfdf;
          .friend {
            background: linear-gradient(180deg, #6c3f91, #b94b71);
            span {
              color: #F0F0F0;
            }
          }
          .mosheng{
            background: linear-gradient(180deg, #3d3a3a, #454141);
            span {
              color: #888;
            }
          }
        }
      }
      
    }
  }
  .no-404 {
    .tip-404 {
      color: #dfdfdf;
    }
  }
}
</style>
